import {
  NOT_GETLISTADO_COMPLETE,
  NOT_GETPUBLICACION_COMPLETE,
  NOT_GETIMG_COMPLETE,
  NOT_GETGRUPOS_COMPLETE,
  NOT_LOADING_COMPLETE,
  NOT_GETNTF_COMPLETE,
} from "../../const/actionTypes";
import { get } from "lodash";

const initialState = {
  listado: [],
  publicaciones: null,
  grupos: [],
  ntf: [],
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case NOT_GETNTF_COMPLETE:
      return { ...state, ntf: get(action, "payload"), loading: false };
    case NOT_GETGRUPOS_COMPLETE:
      return { ...state, grupos: get(action, "payload") };
    case NOT_GETIMG_COMPLETE:
      const parametro = get(action, "payload");
      const newList = [...state.listado];
      let card = newList.find((x) => x.Id === parametro.id);
      card && (card.IMG = parametro.imagen);
      return { ...state, listado: newList, loading: false };
    case NOT_GETLISTADO_COMPLETE:
      return { ...state, listado: get(action, "payload"), loading: false };
    case NOT_GETPUBLICACION_COMPLETE:
      return {
        ...state,
        publicaciones: get(action, "payload"),
        loading: false,
      };
    case NOT_LOADING_COMPLETE:
      return { ...state, loading: get(action, "payload") };
    default:
      return { ...state };
  }
}
